export const SESSION_ENDED_NOTICE = 'Сесію завершено. Авторизація недійсна, увійдіть знову.';

let sessionEndedNotice: string | null = null;
const sessionEndedListeners = new Set<() => void>();

export function markSessionEndedNotice() {
    if (sessionEndedNotice === SESSION_ENDED_NOTICE) {
        return;
    }
    sessionEndedNotice = SESSION_ENDED_NOTICE;
    sessionEndedListeners.forEach((listener) => listener());
}

export function clearSessionEndedNotice() {
    if (!sessionEndedNotice) {
        return;
    }
    sessionEndedNotice = null;
    sessionEndedListeners.forEach((listener) => listener());
}

export function getSessionEndedNotice() {
    return sessionEndedNotice;
}

export function subscribeSessionEndedNotice(listener: () => void) {
    sessionEndedListeners.add(listener);
    return () => {
        sessionEndedListeners.delete(listener);
    };
}

export function resetSessionEndedNoticeForTests() {
    sessionEndedNotice = null;
    sessionEndedListeners.clear();
}
